"use strict";
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./headerSerializer"), exports);
__exportStar(require("./streamManager"), exports);
__exportStar(require("./payloadAssemblerManager"), exports);
__exportStar(require("./payloadTypes"), exports);
__exportStar(require("./requestManager"), exports);
__exportStar(require("./sendOperations"), exports);
__exportStar(require("./streamManager"), exports);
//# sourceMappingURL=index.js.map